import { FieldType } from '@/components/Form';
import { DatabaseField } from '@/modules/corporate/modules/database/fields/types';

import TextFieldEditorConfig from './Editor/config';
import Cell from './Cell';
import { TextFieldStaticConfig } from './config';
import EditableCell from './EditableCell';
import FilterInput from './FilterInput';
import TextOperators from './operators';
import { adaptTextField } from './utils';

const TextField: DatabaseField = {
  ...TextFieldStaticConfig,
  Table: {
    Cell,
    EditableCell,
    FilterInput,
    operators: TextOperators,
  },
  Viewer: {
    fieldType: FieldType.Text,
    adaptFormField: TextFieldEditorConfig.adaptEditorFormField,
  },
  Editor: TextFieldEditorConfig,
  adaptField: adaptTextField,
};

export default TextField;
